import React from 'react';
import { css, StyleSheet } from 'aphrodite';

import { ApiHelper } from '../../../common/helpers/ApiHelper';
import { Helper } from '../../../common/helpers/Helper';
import { BaseEntityPage } from '../../../common/components/BaseEntityPage';
import { UiHelper } from '../../../common/helpers/UiHelper';
import { CustomCbDefFieldsStyles } from '../../../styles/CustomStyles';
import { AppConfig } from '../../../AppConfig';
import { AppStyles } from '../../../styles/AppTheme';

export class NestedFields extends BaseEntityPage {

  constructor(props) {
    super(props);
    this.pageTitle = Helper.getString('nestedfields')
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.cotypeid = this.props.match.params.cotypeid
    this.fieldId = this.props.match.params.id
    this.entityAttrName = 'nestedfields' + this.fieldId
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute() },
      { title: Helper.getString('cotypes'), to: this.baseRoute() + '/cotypes' },
      { title: this.pageTitle },
    ]
    this.toFetch = [
      { method: 'GET', paths: ['cotypes', this.cotypeid], queryParams: { pb: 'fieldDefCoFields' } },
    ]
    this.tableHeadersMap = {
      Order: (current) => { return current.order },
      'Key / Label': (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.label}</span>
            <br/>
            <span className={css(Styles.spanValue, Styles.line2)}>{'{{' + this.field.key + '.' + current.key + '}}'}</span>
          </div>
        )
      },
      Type: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.iType}</span>
          </div>
        )
      },
      Mandatory: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.mandatory}</span>
          </div>
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
      orgId: this.orgId
    }
  }

  onFetchSuccess(results) {
    console.log('CoFields:onFetchSuccess:', results)
    this.field = results[0].fields[this.fieldId]
    this.fieldDef = results[0].fieldDefCoFields
    const iTypeField = this.fieldDef.steps[0].fields.find(i => i.key === 'iType')
    console.log('iTypeField:', iTypeField)
    iTypeField.options = iTypeField.options.filter(i => i.key !== 'NESTED_OBJECT')
    this.formDefinition = this.fieldDef
    this.setState({
      items: Helper.sortDictArray(Helper.dictToArray(results[0][this.entityAttrName]))
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction: 'add', entityAttrName: this.entityAttrName },
      apiEndPoint: ApiHelper.makeUrlPath(['cotypes', this.cotypeid], { }),
    })
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction: 'edit', entityAttrName: this.entityAttrName, id: current.id },
      apiEndPoint: ApiHelper.makeUrlPath(['cotypes', this.cotypeid], { }),
    });
  }

  onDelete(current) {
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction: 'del', entityAttrName: this.entityAttrName, id: current.id },
      apiEndPoint: ApiHelper.makeUrlPath(['cotypes', this.cotypeid], { }),
    });
  }

  onActions = (current) => {
    const actions = []
    actions.push(UiHelper.buttonEdit(this, current))
    actions.push(UiHelper.buttonDelete(this, current))
    return actions
  }
}

const Styles = AppConfig.CUSTOM_STYLE ? CustomCbDefFieldsStyles : StyleSheet.create({
  spanValue: {
    fontSize: 12
  }
})